import React, {useRef} from "react";
import {getCustomerSlotDetails} from "../../services/SessionStorage";
import OfficeSelect from "./office";
import StoreSelect from "./store";

const SelectStore = () => {
  const updatedCustomerSlotDetails = useRef(getCustomerSlotDetails());
  const {isOffice} = updatedCustomerSlotDetails.current;
  return isOffice ? <OfficeSelect /> : <StoreSelect />;
};

export default SelectStore;
